import {
  getDomainTypes,
  selectAllDomainTypes,
  useAppDispatch,
  useAppSelector,
} from '@core/core/store'
import type { DomainType } from '@core/core/types'
import { useEffect } from 'react'

export const useGetDomainItems = (): DomainType[] => {
  const dispatch = useAppDispatch()
  const domainItems = useAppSelector(selectAllDomainTypes)

  useEffect(() => {
    if (!domainItems.length) {
      dispatch(getDomainTypes())
    }
  }, [dispatch, domainItems])

  return domainItems
}
